var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "subscription-manager-v3" },
    [
      _c(
        "h2",
        {
          staticClass: "subscription-manager-v3__title typographies-heading-h2"
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$l10n.__("Mon abonnement Sellsy")) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "CompassTabs",
        {
          model: {
            value: _vm.currentTab,
            callback: function($$v) {
              _vm.currentTab = $$v
            },
            expression: "currentTab"
          }
        },
        [
          _c(
            "CompassTabPane",
            {
              attrs: {
                label: _vm.$t.__("common.labels.subscription"),
                name: "subscription"
              }
            },
            [
              _c("ChargebeeSubscriptionOverviewV3", {
                attrs: {
                  "license-assignement": _vm.licenseAssignement,
                  "chargebee-third-party-payer-id":
                    _vm.chargebeeThirdPartyPayerId
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "CompassTabPane",
            {
              attrs: {
                label: _vm.$t.__("common.labels.invoices_and_credit_notes"),
                name: "invoice",
                disabled: !_vm.documents.length
              }
            },
            [
              _c("documents", {
                attrs: {
                  documents: _vm.documents,
                  "is-chargebee-provider": true
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }